import i18n from '../../../i18n';

// Search URL that keeps the destination, plus the dates and guests of the request just sent,
// in the format the search page reads back (Filters.fromUrl).
export default function contactOtherMembersUrl(search, sentRequest) {
    const bounds = search?.query?.location?.bounds;
    // A map area search stores the translated "selected area" label as place, which is not a destination.
    const slug = !bounds && search?.place ? encodeURIComponent(search.place) : 'everywhere';
    const url = i18n.t('search:search_url', { slug });

    const params = new URLSearchParams();
    if (bounds?.sw && bounds?.ne) {
        params.set('bounds', [bounds.sw.lat, bounds.sw.lon, bounds.ne.lat, bounds.ne.lon].join(','));
    }
    if (sentRequest?.startOn && sentRequest?.endOn) {
        params.set('date_ranges', `${sentRequest.startOn}_${sentRequest.endOn}`);
    }
    const guests = sentRequest?.guests ?? {};
    ['adults', 'children', 'babies'].forEach((type) => {
        if (guests[type] > 0) {
            params.set(type, guests[type]);
        }
    });

    const query = params.toString();
    return query ? `${url}?${query}` : url;
}
